import type { EntityVersionType } from "@/schemas/digital-files";
import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";

interface VersionDropdownProps {
  versions: EntityVersionType[];
  version: number;
  onVersionSelect: (version: EntityVersionType) => void;
}
export const VersionDropdown = ({
  versions,
  version,
  onVersionSelect,
}: VersionDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="tertiary" size="xs" disabled={versions.length === 0}>
          v{version} <Icon type="fas" name="chevron-down" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className={cn(
          "max-h-37.5 min-w-20 rounded-lg border-neutral-silent text-body-loud font-semibold bg-neutral-object",
        )}
      >
        {versions.map((ver) => (
          <DropdownMenuItem
            key={ver.id}
            disabled={ver.version === version}
            onSelect={() => onVersionSelect(ver)}
          >
            v{ver.version}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
